import type { MessageDictionary } from '../types';

// English remains the fallback for pages that have not yet been translated.
// Music registration copy is localized through the shared option dictionary.
export const msMessages: Partial<MessageDictionary> = {
  'i18n.languageSwitcher.label': 'Bahasa',
  'i18n.languageSwitcher.english': 'English',
  'i18n.languageSwitcher.simplifiedChinese': 'Bahasa Cina Ringkas',
  'i18n.languageSwitcher.malay': 'Bahasa Melayu',
};
